import { variants } from './variants';

interface IProps {
  variant?: keyof typeof variants;
  className?: string;
}

export const Divider = ({ variant = 'none', className = '' }: IProps) => (
  <hr className={`border-twilight border-b ${variants[variant]} ${className}`} />
);
